<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="ch00_fm03"></a><a id="page_iii"></a>THE ART OF CONVENING</h1>
<p class="subtitle">AUTHENTIC ENGAGEMENT<br/>IN MEETINGS, GATHERINGS,<br/>AND CONVERSATIONS</p>
<p class="author">By <strong>CRAIG</strong> and <strong>PATRICIA NEAL</strong><br/>with <strong>CYNTHIA WOLD</strong></p>
<p class="pub"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03.vue?63a2a4c5